"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
var _toConsumableArray2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
var _banner = _interopRequireDefault(require("@/components/banner.vue"));
var _search = _interopRequireDefault(require("@/components/search.vue"));
var _menus = _interopRequireDefault(require("@/components/menus.vue"));
var _nav = _interopRequireDefault(require("@/components/nav.vue"));
var _courseItem = _interopRequireDefault(require("@/components/courseItem.vue"));
require("../index.less");
var _courseCard = _interopRequireDefault(require("@/components/courseCard/courseCard.vue"));
var _index2 = require("@/api/virtualSimulationClass/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    CourseCard: _courseCard.default,
    Banner: _banner.default,
    Search: _search.default,
    Nav: _nav.default,
    Menus: _menus.default,
    CourseItem: _courseItem.default
  },
  data: function data() {
    return {
      // imgBanner:require('../../../assets/img/banner3.png'),
      menusList: [{
        tit: '产业分类',
        itemList: [{
          name: '全部',
          id: ''
        }].concat((0, _toConsumableArray2.default)(this.$store.getters.wIndustryType)),
        actheight: false,
        act: 0,
        isZhan: false
      }, {
        tit: '行业门类',
        itemList: [{
          name: '全部',
          id: ''
        }].concat((0, _toConsumableArray2.default)(this.$store.getters.wIndustryCategory)),
        actheight: false,
        act: 0,
        isZhan: true
      }
      //  {
      //    tit:'级别',
      //    itemList:[{name:'全部',id:''},...this.$store.getters.wProjectLevel],
      //    actheight:false,
      //    act:0,
      //    isZhan:false,
      //  },
      ],
      query: {
        courseEmceeName: "",
        courseLevel: "",
        courseName: "",
        courseType: "7",
        // courseTypeList: [],
        fkCourseMajor: "",
        industry: "",
        industryDetail: "",
        majorName: "",
        pageNum: 1,
        pageSize: 20,
        project: "",
        provinceId: "",
        schoolId: "",
        schoolLevel: "",
        showStatus: 1,
        year: ""
      },
      list: [],
      total: 0,
      loading: false
    };
  },
  methods: {
    toSsearch: function toSsearch(e) {
      // console.log('dianji', e.majorId)
      this.query.courseName = e.courseName;
      if (e.majorName == '全部') {
        this.query.majorName = '';
      } else {
        this.query.majorName = e.majorName;
      }
      this.getList();
    },
    chooseList: function chooseList(e) {
      console.log('dianji', e);
      if (e[0] == '产业分类') {
        if (e[1].name == '全部') {
          this.query.industry = '';
        } else {
          this.query.industry = e[1].name;
        }
      } else if (e[0] == '行业门类') {
        this.query.industryDetail = e[1].remark;
      }
      this.query.pageNum = 1;
      this.getList();
    },
    // 获取课程
    getList: function () {
      var _getList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.loading = true;
              _context.next = 1;
              return (0, _index2.getReceptionList)(this.query);
            case 1:
              res = _context.sent;
              if (res.code == 200) {
                this.list = res.rows;
                this.total = res.total;
                this.loading = false;
              }
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }(),
    handleCurrentChange: function handleCurrentChange(e) {
      this.query.pageNum = e;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.query.pageSize = e;
      this.query.pageNum = 1;
      this.getList();
    }
  },
  created: function () {
    var _created = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 1;
            return this.getList();
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }()
};